import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { AppThunk, AppDispatch } from "@/app/store";
import { purgeInvoices } from "../api/purgeInvoices/purgeInvoicesApi";

interface PurgeInvoicesState {
  purgeLoading: boolean;
  purgeError: string | null;
}

const initialState: PurgeInvoicesState = {
  purgeLoading: false,
  purgeError: null,
};

const purgeInvoicesSlice = createSlice({
  name: "purgeInvoices",
  initialState,
  reducers: {
    setPurgeLoading: (state, action: PayloadAction<boolean>) => {
      state.purgeLoading = action.payload;
    },
    setPurgeError: (state, action: PayloadAction<string | null>) => {
      state.purgeError = action.payload;
    },
  },
});

export const { setPurgeLoading, setPurgeError } = purgeInvoicesSlice.actions;

export const purgeInvoicesAction =
  (intacctId: string): AppThunk =>
  async (dispatch: AppDispatch) => {
    dispatch(setPurgeLoading(true));
    dispatch(setPurgeError(null));
    try {
      await purgeInvoices(intacctId);
    } catch (error) {
      dispatch(
        setPurgeError(
          error instanceof Error ? error.message : "Failed to purge invoices",
        ),
      );
      throw error;
    } finally {
      dispatch(setPurgeLoading(false));
    }
  };

export default purgeInvoicesSlice.reducer;
